import React, { useEffect, useState } from 'react';
import { sp } from './sponsorApi';
import { DatePickerFr } from '../../components/ui/DatePickerFr';
import { CalendarDays, Plus, Bell, Loader2, MapPin, Users } from 'lucide-react';

export default function EvenementsTab() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ title: '', description: '', event_date: '', location: '', capacity: '' });
  const [msg, setMsg] = useState('');

  const load = async () => {
    setLoading(true);
    try { const r = await sp.get('/evenements'); setEvents(r.data.evenements || []); }
    catch { /* noop */ } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    setMsg('');
    if (!f.title || !f.event_date) { setMsg('Titre et date requis.'); return; }
    try {
      await sp.post('/evenements', { ...f, capacity: parseInt(f.capacity, 10) || null });
      setF({ title: '', description: '', event_date: '', location: '', capacity: '' }); await load();
    } catch (e) { setMsg(e?.response?.data?.detail || 'Échec.'); }
  };
  const register = async (id) => { try { await sp.post(`/evenements/${id}/inscription`, {}); await load(); } catch (e) { setMsg(e?.response?.data?.detail || 'Échec.'); } };
  const unregister = async (id) => { await sp.del(`/evenements/${id}/inscription`); await load(); };

  if (loading) return <div className="flex items-center gap-2 text-slate-400"><Loader2 className="w-5 h-5 animate-spin" /> Chargement…</div>;

  return (
    <div className="space-y-8" data-testid="evenements-tab">
      <section className="bg-slate-900 border border-slate-800 rounded-xl p-6">
        <div className="flex items-center gap-2 text-emerald-400 mb-4"><Plus className="w-5 h-5" /><h2 className="text-white font-semibold">Proposer un événement</h2></div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Titre" data-testid="ev-title-input" className="md:col-span-2 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
          <DatePickerFr value={f.event_date} onChange={(v) => setF({ ...f, event_date: v })} id="ev-date-input" className="w-full" />
          <input type="number" value={f.capacity} onChange={(e) => setF({ ...f, capacity: e.target.value })} placeholder="Places (opt.)" data-testid="ev-capacity-input" className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
          <input value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} placeholder="Lieu" data-testid="ev-location-input" className="md:col-span-2 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
          <textarea value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Description" rows={2} data-testid="ev-desc-input" className="md:col-span-4 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
        </div>
        <button onClick={create} disabled={!f.title || !f.event_date} data-testid="ev-create-btn" className="mt-3 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-1"><Plus className="w-4 h-4" />Publier</button>
        {msg && <p className="text-sm text-amber-300 mt-2" data-testid="ev-msg">{msg}</p>}
      </section>

      <section className="bg-slate-900 border border-slate-800 rounded-xl p-6">
        <div className="flex items-center gap-2 text-emerald-400 mb-4"><CalendarDays className="w-5 h-5" /><h2 className="text-white font-semibold">Agenda partagé</h2></div>
        <ul className="space-y-2">
          {events.length === 0 && <li className="text-slate-500 text-sm" data-testid="ev-empty">Aucun événement à venir.</li>}
          {events.map((e) => (
            <li key={e.id} className="flex items-center justify-between bg-slate-800/60 rounded-lg px-3 py-3 text-sm" data-testid={`ev-${e.id}`}>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-white font-medium">{e.title}</span>
                  {e.reminder && <span className="text-amber-300 text-xs flex items-center gap-1" data-testid={`ev-reminder-${e.id}`}><Bell className="w-3 h-3" />bientôt</span>}
                </div>
                <p className="text-slate-500 text-xs mt-0.5">{e.event_date} · {e.organisateur}{e.location ? ` · ` : ''}{e.location && <span className="inline-flex items-center gap-0.5"><MapPin className="w-3 h-3" />{e.location}</span>}</p>
                <p className="text-slate-500 text-xs flex items-center gap-1"><Users className="w-3 h-3" />{e.registrations_count} inscrit(s){e.capacity ? ` / ${e.capacity}` : ''}</p>
              </div>
              {e.is_registered
                ? <button onClick={() => unregister(e.id)} data-testid={`ev-unregister-${e.id}`} className="text-slate-400 hover:text-white text-xs">Se désinscrire</button>
                : <button onClick={() => register(e.id)} data-testid={`ev-register-${e.id}`} className="text-emerald-400 hover:text-emerald-300 text-xs font-semibold">S'inscrire</button>}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
